// This whole component was added as part of dcbc5616-property-highlights-v1
export {PropertyHighlights} from './PropertyHighlights'
export type {PropertyHighlight} from './types'
export {
  usePropertyHighlights,
  usePropertyHighlightsAnalyticsPayload
} from './usePropertyHighlights'
